import { CategoryName, DbId } from '@infotech-soe/metaschema';
import { createSlice } from '@reduxjs/toolkit';

import { DocLinksMode } from '../../models/docLinks/docLinks';

import { failureAction, pendingAction, successAction } from './actionHandler';

const docLinksSlice = createSlice({
  name: 'docLinks',
  initialState: null,
  reducers: {
    open: pendingAction<
      unknown,
      {
        categoryName: CategoryName;
        docId: DbId;
        mode: DocLinksMode;
      }
    >(),
    openSuccess: successAction(),
    openFailure: failureAction(),
    openDocs: pendingAction<
      unknown,
      {
        categoryName: CategoryName;
        docId: DbId;
        sourceCategoryName: CategoryName;
        mode: DocLinksMode;
      }
    >(),
    openDocsSuccess: successAction(),
    openDocsFailure: failureAction(),
  },
});

export default docLinksSlice.actions;
